import { hetsApi } from "@/apis/interceptor"
import { IAttachmentUrlDto, IAttachmentUrlResponse, IHeTimesheet, IHeTimesheetDto, IHeTimesheetResponse, IHeTimesheetSpvParams, IHeTimesheetUpdateDto, IPaginationParam, IResponse } from "@/types"

export const heTimesheetsService = {
  createHeTimesheet: async (dto: IHeTimesheetDto): Promise<IResponse<IHeTimesheet>> => {
    const formData = new FormData()

    Object.entries(dto).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value)
      } else if (value !== undefined && value !== null) {
        formData.append(key, String(value))
      }
    })

    const response = await hetsApi.post<IResponse<IHeTimesheet>>("/v1/hets", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },

  getHeTimesheets: async (params?: IPaginationParam): Promise<IResponse<IHeTimesheetResponse>> => {
    const response = await hetsApi.get<IResponse<IHeTimesheetResponse>>("/v1/hets/operators", { params })
    return response.data
  },

  getHeTimesheetsSupervisor: async (params?: IHeTimesheetSpvParams): Promise<IResponse<IHeTimesheetResponse>> => {
    const response = await hetsApi.get<IResponse<IHeTimesheetResponse>>('/v1/hets/supervisor', { params })
    return response.data
  },

  getHeTimesheetById: async (recordId: string): Promise<IResponse<IHeTimesheet>> => {
    const response = await hetsApi.get<IResponse<IHeTimesheet>>(`/v1/hets/${recordId}`)
    return response.data
  },

  getHeTimesheetAttachmentUrl: async (dto: IAttachmentUrlDto): Promise<IResponse<IAttachmentUrlResponse>> => {
    const response = await hetsApi.get<IResponse<IAttachmentUrlResponse>>(`/v1/hets/attachment-url`, { params: { key: dto.key } })
    return response.data
  },

  updateHeTimesheet: async (dto: IHeTimesheetUpdateDto, recordId: string): Promise<IResponse<IHeTimesheet>> => {
    const formData = new FormData()

    Object.entries(dto).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value)
      } else if (value !== undefined && value !== null) {
        formData.append(key, String(value))
      }
    })

    const response = await hetsApi.put<IResponse<IHeTimesheet>>(`/v1/hets/${recordId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  }
}
